<script>
import { getCaptchaConfig } from '@/api/configs';

export default {
  name: 'Captcha',
  data: () => ({
    captcha: null,
    loading: false
  }),
  props: {
    config: String,
    altInfo: {
      type: String,
      default: '点击刷新'
    }
  },
  created() {
    this.getCaptchaConfig();
  },
  methods: {
    async reload() {
      await this.getCaptchaConfig();
    },
    async getCaptchaConfig() {
      this.loading = true;
      try {
        const { data } = await getCaptchaConfig(this.config);
        this.captcha = data;
        this.$refs.vcode.setAttribute('src', data.img);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    captcha(newVal) {
      this.$emit('captcha', newVal);
    }
  },
  render(h) {
    return (
      <div v-on:click={this.getCaptchaConfig} v-loading={this.loading} class="captcha-wrapper" title={this.altInfo}>
        <img ref="vcode" src="" alt={this.altInfo} />
      </div>
    );
  }
};
</script>

<style scoped lang="less">
.captcha-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  i {
    font-size: 16px;
  }
}
</style>
